import React from "react";
import { EventThumbnail } from "../../event";
import { Button } from "../../Button";
import { Svg } from "../../Svg";
import { cn } from "../../../../utils";

export const CARD_EVENT_THUMBNAIL_SIZE = 425;

interface CardEventProps {
  sponsored?: boolean;
  date: string;
  imageUrl: string | null;
  eventName: string;
  subtitle?: string | null;
  location: string | null | undefined;
  tags: string[];
  isTicketingAvailable: boolean;
  onClick?: () => void;
}

const CardEvent: React.FC<CardEventProps> = ({
  sponsored = false,
  date,
  imageUrl,
  eventName,
  subtitle,
  location,
  tags,
  isTicketingAvailable,
  onClick,
}) => {
  return (
    <Button
      onClick={onClick}
      variant="null"
      className="size-full p-0 text-start"
      data-testid="event-card"
    >
      <div className="flex w-full flex-col gap-1">
        <div className="relative h-[120px] w-full overflow-hidden rounded-lg">
          <EventThumbnail
            imageUrl={imageUrl || "/images/event.jpeg"}
            altContent="event"
            className="size-full"
            objectFit="auto"
          />
          {sponsored && (
            <p className="absolute right-2 top-2 z-20 rounded-lg bg-orange-500 px-2 py-1 text-xs font-semibold text-white">
              Sponsorisé
            </p>
          )}
          <p className="absolute left-2  top-2 z-20 rounded-full bg-gray-100 px-2 py-1 text-xs font-semibold text-black">
            {date}
          </p>
          {isTicketingAvailable && (
            <div className="absolute bottom-2 right-2 z-20 flex items-center gap-1 rounded-full bg-white px-2 py-1">
              <Svg
                name={"ticket_orange_100"}
                isColored
                alt={"ticket"}
                width={14}
              />
              <span className="text-xs font-semibold text-gray-600">
                Billetterie disponible
              </span>
            </div>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <h2 className="truncate text-lg font-semibold text-black">
            {eventName}
          </h2>
          {subtitle && (
            <p className="text-wrap break-words text-sm font-semibold text-gray-600">
              {subtitle}
            </p>
          )}
          <div className="flex gap-1 text-wrap break-words text-sm font-semibold text-gray-600">
            <Svg name="mapIn" alt="mapIn" width={16} />
            {location}
          </div>
          <div className="flex items-center gap-2">
            {tags.includes("indoor") && (
              <div className="flex items-center rounded-full border border-orange-200 bg-orange-50 px-2 py-1 text-xs font-semibold text-orange-700">
                Intérieur
              </div>
            )}
            {tags.includes("outdoor") && (
              <div className="flex items-center rounded-full border border-green-200 bg-green-50 px-2 py-1 text-xs font-semibold text-green-700">
                Extérieur
              </div>
            )}
            {tags.includes("paid") && (
              <div className="flex items-center rounded-full border border-purple-200 bg-purple-50 px-2 py-1 text-xs font-semibold text-purple-700">
                Payant
              </div>
            )}
            {tags.includes("free") && (
              <div className="flex items-center rounded-full border border-[#D6D7FE] bg-[#F3F3FF] px-2 py-1 text-xs font-semibold text-[#2825DC]">
                Gratuit
              </div>
            )}
          </div>
        </div>
      </div>
    </Button>
  );
};

export default CardEvent;
